import { render } from "./FbnSearch.vue?vue&type=template&id=1da38ad1&scoped=true"
import script from "./FbnSearch.vue?vue&type=script&lang=js"
export * from "./FbnSearch.vue?vue&type=script&lang=js"

import "./FbnSearch.vue?vue&type=style&index=0&id=1da38ad1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da38ad1"]])

export default __exports__